import Search from '@mui/icons-material/Search';
import {
  Box,
  Button,
  Input,
  InputAdornment,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import Page from 'components/Page';
import { Table, Td, Th, Tr } from 'components/Table';
import useNotice from 'hook/useNotice';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootStyle } from './style';

const Avatar = styled('img')`
  width: 36px;
  margin-right: 12px;
`;
export function Notice() {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const { data } = useNotice();
  return (
    <Page
      actions={
        <Button
          variant='contained'
          onClick={() => {
            navigate(`/notice/modify/1`);
          }}
        >
          새로 만들기
        </Button>
      }
    >
      <Stack flexDirection='row' justifyContent='flex-end' mb={4}>
        <Box>
          <Input
            id='input-with-icon-adornment'
            placeholder='코치를 검색하세요'
            startAdornment={
              <InputAdornment position='start'>
                <Search />
              </InputAdornment>
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
      </Stack>
      <Table>
        <Tr>
          <Th width='300px'>제목</Th>
          <Th>카테고리</Th>
          <Th>팝업 노출기간</Th>
          <Th>앱 버전</Th>
        </Tr>
        {data?.data.items.map((item) => (
          <Tr>
            <Td
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(`/notice/modify/${item.id}`);
              }}
              width='300px'
            >
              <Typography fontWeight={700}>{item.title}</Typography>
            </Td>
            <Td>{item.category}</Td>
            <Td>
              {item.popup_period_start_date}~{item.popup_period_end_date}
            </Td>
            <Td>{item.app_version}</Td>
          </Tr>
        ))}
      </Table>
    </Page>
  );
}
